module.exports = __webpack_public_path__ + "static/media/avatar-2.303222e7.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/avatars/avatar-2.png
// module id = 241
// module chunks = 0